import { THEME_MOOD } from "./constants"

export const changeTheme = mood => dispatch => {
  dispatch({ type: THEME_MOOD, payload: mood })
}
